module.exports = __webpack_public_path__ + "0c3201b9fd2b66dcb26c4040fa92e3e3.svg";